import { Reveal, Stagger, StaggerItem, SectionNo, Hairline, MaskReveal } from "@/components/primitives";
import AmbientBand from "@/components/AmbientBand";
import BigSectionNo from "@/components/BigSectionNo";

const ARCHETYPES = [
  { name: "Independent luxury hotels", note: "one property, one standard" },
  { name: "Hotel groups & collections", note: "one visual language, every address" },
  { name: "Boutique groups", note: "a handful of addresses, one voice" },
  { name: "Resorts & villa collections", note: "space that deserves to move" },
  { name: "Restaurant & bar groups", note: "atmosphere is the product" },
  { name: "Spa & wellness", note: "stillness, shown in motion" },
  { name: "Destination marketing", note: "a place, not a property" },
];

const MARQUES = [
  "Relais & Châteaux",
  "Leading Hotels of the World",
  "Small Luxury Hotels",
  "Design Hotels",
];

export default function WhoFor() {
  return (
    <section id="who" className="relative overflow-hidden px-6 py-20 sm:px-10 md:py-28 warm-radial" data-testid="who-for">
      <AmbientBand loop="L05" texture="T08" opacity={0.06} />
      <BigSectionNo n="05" />
      <div className="relative mx-auto max-w-[1280px]">
        <Hairline className="mb-20" />
        <Reveal>
          <SectionNo n="05" label="Who this is for" />
        </Reveal>

        <h2
          className="display mt-8 max-w-3xl text-primaryText"
          style={{
            fontSize: "clamp(2.25rem, 5vw, 4rem)",
            lineHeight: 1.02,
            letterSpacing: "-0.015em",
            fontWeight: 300,
          }}
        >
          <MaskReveal>We work best with properties</MaskReveal>
          <MaskReveal delay={0.1}>that already care how they look.</MaskReveal>
        </h2>

        <Stagger className="mt-16 grid gap-x-10 gap-y-2 sm:grid-cols-2 lg:grid-cols-3">
          {ARCHETYPES.map((a) => (
            <StaggerItem key={a.name}>
              <div className="group border-b border-hairline py-6 transition-colors duration-300 hover:border-gold/50">
                <h3
                  className="display text-primaryText transition-colors duration-300 group-hover:text-gold"
                  style={{ fontSize: "clamp(1.25rem, 1.6vw, 1.5rem)", fontWeight: 300, letterSpacing: "-0.005em", lineHeight: 1.15 }}
                >
                  {a.name}
                </h3>
                <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.22em] text-mutedText/70">
                  {a.note}
                </p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>

        <Reveal delay={0.1}>
          <div className="mt-16 rounded-[3px] border border-gold/25 bg-surface/40 p-8 sm:p-10">
            <p className="max-w-2xl text-base leading-relaxed text-mutedText">
              If your property carries one of these marques, you already hold
              the standard we work to:
            </p>
            <ul className="mt-6 flex flex-wrap gap-x-10 gap-y-3" data-testid="marques">
              {MARQUES.map((m) => (
                <li key={m} className="display text-xl text-primaryText sm:text-2xl">
                  {m}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
